// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__3NwmB","header":"PatientQuestionnaire_header__2GM5u","info":"PatientQuestionnaire_info__2KEtG"};